<template>
  <v-navigation-drawer
      width="325"
      temporary
      v-model="showLocal"
      right fixed
      class="py-2 pl-2 pr-3"
  >
<!--    <v-btn-->
<!--        icon-->
<!--        x-small fab-->
<!--        absolute :style="{top: '0.6%', right: '7%'}"-->
<!--        @click="showLocal = false"-->
<!--    >-->
<!--      <v-icon>close</v-icon>-->
<!--    </v-btn>-->

    <customer-cart-detail
        flat
        :show-actions="true"
        @next="$emit('next')"
        @close="showLocal = false"
    ></customer-cart-detail>
  </v-navigation-drawer>
</template>

<script>
import CustomerCartDetail from "@/modules/delivery/components-core/customer/CustomerCartDetail/CustomerCartDetail.vue";

export default {
  name: "CustomerNavigationCartDetail",
  components: {CustomerCartDetail},
  props:{
    value: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    showLocal:{
      get(){
        return this.value;
      },
      set(value){
        this.$emit('input', value);
      }
    }
  }
}
</script>

<style scoped>

</style>
